
<template>
  <div class="paymentResult">
    <div class="header">
      <div class="headerDiv">
        <div class="call_back" @click="reBack">
          <img src="../../assets/shared-hotel/call.png" />
        </div>
      </div>
    </div>
    <div class="content">
      <div class="img">
        <img :src="ok" />
      </div>
      <p class="title">{{str}}</p>
      <p class="money"><span>¥</span><span>{{actual_amount}}</span></p>
      <div class="pre">
        <van-row class="or_operation_div">
          <van-col class="left" span="11">
            <div @click="handleHome">返回首页</div>
          </van-col>
          <van-col span="2"></van-col>
          <van-col class="right" span="11">
            <div @click="handleOrder">查看订单</div></van-col
          >
        </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      ok: require("@/assets/shared-hotel/result.png"),
      str:'充值成功',
      actual_amount:0.00
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }
    if(this.$route.query.type&&this.$route.query.type==1){
        this.str='核销成功';
    }
    if(this.$route.query.actual_amount){
        this.actual_amount=this.$route.query.actual_amount;
    }
  },
  mounted() {},
  computed: {},
  methods: {
    handleHome() {//返回到共享饭店首页
        this.$router.push({
            path: "/sharedHotel/store",
            query: {
                long: localStorage.getItem('longitude'),
                lat:localStorage.getItem('latitude'),
                from:'h5'
                },
        });
    },
    handleOrder() {//返回到使用记录
      this.$router.push({
        path: "/sharedHotel/usageRecord",
        query: {
          paytype: this.$route.query.type,
          entrance: true,
        },
      });
    },
    reBack() {//返回到店铺详情
    if(this.$route.query.type==1){
        this.$router.go(-2)
    }else{
        this.$router.push({
            path: "/sharedHotel/storeDetail",
            query: {
                id: this.$route.query.shop_id,
                lng: localStorage.getItem('longitude'),
                lat: localStorage.getItem('latitude'),
                entrance:true
            },
        });
    }
    
    },
  },
};
</script>

<style lang="less" scoped>
.paymentResult {
  background-color: #f5f5f5;
  height: 100%;
}
.header {
  // height: 48px;
  // background-color: #fff;
  text-align: center;
  padding-top: 44px;
  box-sizing: border-box;
  position: fixed;
  display: revert;
  top: 0;
  width: 100%;
  z-index: 999;
}
.headerDiv {
  width: calc(100% - 40px);
  margin: 0 auto;
  display: flex;
}
.call_back {
  img {
    width: 18px;
    height: 18px;
    margin-top: 16px;
  }
}

.content {
  padding-top: 100px;
  .img {
    text-align: center;
    margin: 85px 0 0;
    img {
      width: 65px;
      height: 65px;
    }
  }
  .title {
    text-align: center;
    color: #F9591B;
    font-size: 18px;
    font-weight: 400;
    margin: 10px 0;
  }
  .money{
    text-align: center;
    color: #333;
    font-size: 20px;
    font-weight: bold;
    span:nth-child(2){
        font-size: 36px;
    }
  }
  .pre {
    width: calc(100% - 130px);
    margin: 40px auto 0;
  }
  .left,
  .right {
    div {
      width: 100%;
      line-height: 34px;
      color: #666;
      border: 1px solid #999;
      text-align: center;
      border-radius: 20px;
      font-size: 14px;
    }
  }
}
</style>
